import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { checkoutHasPreselectedUpstreamInsurance } from 'checkout/selectors/view/insurance'

interface Options {
  /**
   * The experiment activates when a CoverGenius insurance price is actually on screen, so every
   * arm activates on the same audience. Callers pass whether their quote has resolved: the
   * checkout insurance sections, the product items, the spoofed insurance options and the
   * post-purchase upsells. A loading skeleton or a failed quote does not count as exposure.
   */
  canActivate: boolean
  /**
   * Customers who arrive at checkout with protection already selected upstream (a protected flight
   * fare or a bedbank CFMR flex bundle) keep the base price and are not enrolled. Post-purchase
   * upsells are a fresh insurance decision by definition and skip that gate, which reads incidental
   * checkout-cart state.
   */
  isFreshInsuranceDecision?: boolean
}

function useInsurancePriceExperiment({ canActivate, isFreshInsuranceDecision = false }: Options) {
  const hasPreselectedUpstreamInsurance = useAppSelector(checkoutHasPreselectedUpstreamInsurance)
  const eligible = isFreshInsuranceDecision || !hasPreselectedUpstreamInsurance

  return useExperiment(ChertoExperiments.croInsurancePriceIncreaseV2, { canActivate: canActivate && eligible })
}

export default useInsurancePriceExperiment
